module.exports = __webpack_public_path__ + "img/na.31079a3b.svg";